function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import '../styles/dropdown.css';

export default {
  name: 'v-dropdown',
  props: {
    align: {
      type: String,
      default: 'left'
    },
    embed: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: true
    },
    rightClick: {
      type: Boolean,
      default: false
    },
    toggle: {
      type: Boolean,
      default: true
    },
    manual: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    animated: {
      type: [String, Boolean],
      default: true
    },
    width: Number,
    dropWidth: Number,
    dropClass: '',
    fullWidth: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      show: false,
      styleSheet: { top: '', left: '' },
      dropdownClass: 'v-dropdown-container',
      dropUp: false,
      x: null,
      y: null
    };
  },

  computed: {
    animate: function animate() {
      if (typeof this.animated === 'string') return this.animated;
      if (!this.embed && this.animated) return this.dropUp ? 'animate-up' : 'animate-down';
      return '';
    }
  },
  render: function render(h) {
    var _class,
        _this = this;

    var children = [];
    if ('caller' in this.$scopedSlots && !this.embed) {
      children.push(this.$scopedSlots.caller());
    }
    children.push(h('transition', {
      props: {
        name: this.animate
      }
    }, [h('div', {
      class: (_class = {}, _defineProperty(_class, this.dropClass, this.dropClass !== ''), _defineProperty(_class, this.dropdownClass, true), _defineProperty(_class, 'v-dropdown-embed', this.embed), _defineProperty(_class, 'v-dropdown-no-border', !this.border), _class),
      style: this.styleSheet,
      directives: [{ name: 'show', value: this.show }],
      ref: 'dropdown',
      on: {
        mousedown: function mousedown(e) {
          e.stopPropagation();
        }
      }
    }, this.$slots.default)]));
    return h('div', {
      class: {
        'v-dropdown-caller': true,
        'v-dropdown-caller--full-width': this.fullWidth
      },
      on: {
        click: function click(e) {
          if (_this.embed || _this.rightClick || _this.manual) return;
          e.stopPropagation();
          _this.visible();
        },
        // 鼠标点击
        contextmenu: function contextmenu(e) {
          if (_this.embed || _this.manual || !_this.rightClick) return;
          e.stopPropagation();
          e.preventDefault();

          var info = _this.scrollInfo();
          _this.x = e.pageX || e.clientX + info.x;
          _this.y = e.pageY || e.clientY + info.y;
          _this.visible();
        }
      }
    }, children);
  },

  methods: {
    visible: function visible() {
      var outside = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.disabled) return;
      if (this.show && !this.toggle && !outside) return;
      // 计算向上或者向下展示
      if (!this.show && !this.embed && this.$slots.caller) this.adjust();

      this.show = !this.show;
      this.$emit('show', this.show);
    },

    /**
     * 点击其他位置隐藏
     */
    whole: function whole(e) {
      var _this2 = this;

      if (this.show) {
        var inCaller = this.eventPath(e).findIndex(function (val) {
          return val === _this2.$el;
        }) !== -1;
        if (inCaller && !this.toggle && !this.rightClick) return;
        if (!inCaller || inCaller && this.rightClick) {
          this.visible(true);
        }
      }
    },

    /**
     * 调整下拉显示位置
     */
    adjust: function adjust() {
      var pos = this.$el.getBoundingClientRect();
      var menu = null;

      if (this.show) menu = this.$refs.dropdown.getBoundingClientRect();else {
        this.$refs.dropdown.style.visibility = 'hidden';
        this.$refs.dropdown.style.display = 'inline-block';
        menu = this.$refs.dropdown.getBoundingClientRect();
        // 获取位置数据后恢复下拉样式
        this.$refs.dropdown.style.visibility = 'visible';
        this.$refs.dropdown.style.display = 'none';
      }

      this.adjustTop(pos, menu);
      this.styleSheet.left = this.adjustLeft(pos, menu) + 'px';
      this.styleSheet.width = pos.width + 'px';
    },

    /**
     * 计算顶部方向
     */
    adjustTop: function adjustTop(pos, menu) {
      var gap = 5;
      var scrollTop = window.pageYOffset;
      var viewHeight = document.documentElement.clientHeight;
      var srcTop = this.rightClick ? this.y : pos.top + scrollTop;
      var t = this.rightClick ? this.y : pos.top + pos.height + gap + scrollTop;
      var overDown = false;var overUp = false;var up = false;
      if (t + menu.height + 20 > scrollTop + viewHeight) overDown = true;
      if (srcTop - gap - menu.height < scrollTop) overUp = true;

      if (!overUp && overDown) {
        t = srcTop - gap - menu.height;
        up = true;
      }
      this.dropUp = up;
      this.styleSheet.top = t + 'px';
      if (pos.top < 60 || pos.top > document.documentElement.clientHeight) {
        this.$refs.dropdown.style.display = 'none';
      } else {
        if (this.show) {
          this.$refs.dropdown.style.display = 'inline-block';
        }
      }
    },
    adjustLeft: function adjustLeft(pos, menu) {
      var scrollLeft = window.pageXOffset;var viewWid = document.documentElement.clientWidth;
      var wid = this.rightClick ? 0 : pos.width;
      var left = this.rightClick ? this.x : pos.left + scrollLeft;
      var center = left + wid / 2 - menu.width / 2;
      var right = left + wid - menu.width;

      switch (this.align) {
        case 'left':
          return left + menu.width > scrollLeft + viewWid ? right : left;
        case 'center':
          if (center + menu.width > scrollLeft + viewWid) return right;else if (right < scrollLeft) return left;else return center;
        case 'right':
          return right < scrollLeft ? left : right;
      }
    },
    scrollInfo: function scrollInfo() {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || '') === 'CSS1Compat';

      return {
        x: supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
        y: supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
      };
    },

    /**
     * 返回事件的路径，该路径是将在其上调用侦听器的对象数组
     */
    eventPath: function eventPath(e) {
      if ('composedPath' in e) return e.composedPath();
      if ('path' in e) return e.path;
      var path = [];
      var currentElem = e.target;
      while (currentElem) {
        path.push(currentElem);
        currentElem = currentElem.parentElement;
      }
      if (path.indexOf(window) === -1 && path.indexOf(document) === -1) path.push(document);
      if (path.indexOf(window) === -1) path.push(window);
      return path;
    },
    isIE: function isIE() {
      // ie?
      if (!!window.ActiveXObject || 'ActiveXObject' in window) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.adjust, true);
    if (this.width) this.styleSheet.width = this.width + 'px';
    if (this.embed) this.visible();else {
      document.body.appendChild(this.$refs.dropdown);
      document.body.addEventListener('mousedown', this.whole);
    }
    if (this.dropWidth > 0) this.styleSheet['min-width'] = this.dropWidth + 'px';
  },
  beforeDestroy: function beforeDestroy() {
    // 删除下拉层
    if (!this.embed) {
      document.body.removeEventListener('mousedown', this.whole);
      if (this.isIE()) {
        this.$refs.dropdown.removeNode(true);
      } else {
        this.$refs.dropdown.remove();
      }
      //
    }
    window.removeEventListener('scroll', this.adjust, true);
  },
  destroyed: function destroyed() {
    if (!this.embed) {
      if (this.isIE()) {
        this.$el.removeNode(true);
      } else {
        this.$el.remove();
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./src/component/dic/components/Dropdown.js
// module id = 8
// module chunks = 0